import React, { useEffect } from 'react';
import CuiButton from '../CuiComponents/Button';
import CuiIcon from '../CuiComponents/Icon';
import FocusTrap from 'focus-trap-react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { navigate } from '../../redux/actions/CourseActions';
import Moment from 'react-moment';
import { useTranslation } from 'react-i18next';
import { actionsToHideModal } from '../../redux/actions/AppHeaderModalActions';
import useXapi from '../../Hooks/useXapi';
import { pseudolocalize } from '../Block/common/pseudolocalize/pseudolocalize';
import './RecentlyViewed.scss';

const RecentlyViewed = () => {
  const { xApiEvent } = useXapi();
  const { t } = useTranslation();
  const { recentlyViewed, courseId, isPseudo } = useSelector(
    state => ({
      recentlyViewed: state.RecentViewsState.recentlyViewed,
      courseId: state.CourseState.courseId,
      isPseudo: state.LanguageState.isPseudo
    }),
    shallowEqual
  );
  const dispatch = useDispatch();
  // get recent views for the course we're in.
  const courseRv = recentlyViewed[courseId];

  const bodyEle = document.getElementsByTagName('body')[0];
  // prevent background scrolling while the bookmarks modal is visible
  useEffect(() => {
    bodyEle.style.cssText =
      'overflow: hidden; height: auto; padding-right: 15px;';
    return function cleanup() {
      bodyEle.style.cssText = '';
    };
  });

  return (
    <FocusTrap>
      <div className="rv-outer">
        <div className="row rv-header-stuck">
          <div className="col-sm-12">
            <div>
              <div className="icon-circle-wrap">
                <CuiIcon icon="recent-apps" size="medium" />
              </div>
              <h1>{t('RecentlyViewed.recentlyViewed')}</h1>
            </div>
            <CuiButton
              id="close-btn"
              icon="close"
              onClick={() => {
                xApiEvent(
                  'Recently Viewed Pages Modal Closed',
                  window.location.href
                );
                dispatch(actionsToHideModal('HIDE_RV'));
              }}
            />
          </div>
        </div>
        <div className="timeline-container">
          <div className="row">
            <div className="col-sm-12">
              <div className="timeline">
                <div className="timeline__list">
                  {courseRv.map((rv, i) => {
                    return (
                      <div key={i} className="timeline__item">
                        <div className="timeline__icon timeline--default"></div>
                        <div className="timeline__time">
                          <Moment fromNow>{rv.date}</Moment>
                        </div>
                        <div className="timeline__content">
                          <div className="module">
                            {isPseudo ? pseudolocalize(rv.module) : rv.module}
                          </div>
                          <a
                            href={`#${rv.li}`}
                            className="block"
                            onClick={e => {
                              e.preventDefault();
                              dispatch(navigate(rv));
                            }}
                          >
                            {isPseudo ? pseudolocalize(rv.block) : rv.block}
                          </a>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FocusTrap>
  );
};

export default RecentlyViewed;
